import { createClient } from '@supabase/supabase-js'

// const supabaseUrl = 'https://rueteqklzjxbfjaplsrk.supabase.co';
// const supabaseAnonKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InJ1ZXRlcWtsemp4YmZqYXBsc3JrIiwicm9sZSI6ImFub24iLCJpYXQiOjE3MTkyNjA2NzgsImV4cCI6MjAzNDgzNjY3OH0.zK6sjD3xSfTwQ-XCQJCdCU-5GoTdpO9hwqnrRM6YKSY';
const supabaseUrl = 'https://tosbulufqhlxbfgswvnv.supabase.co';
const supabaseAnonKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InRvc2J1bHVmcWhseGJmZ3N3dm52Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTI2ODI5NjgsImV4cCI6MjA2ODI1ODk2OH0.lBql2K_05LQiF23wesVpCPB03h90Wqut7G2MPOpBeoQ';

export const supabase = createClient(supabaseUrl, supabaseAnonKey);
